import { shouldTableSortByRenewTime } from 'owa-mail-list-response-processor';
import { MailSortHelper } from 'owa-mail-list-store';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import sortResults from 'owa-service/lib/factory/sortResults';
/**
 * Gets the sortBy property depending on the folder
 * @param tableQuery tableQuery of the conversation type table for which to get the sortBy property
 * @return sortBy - a collection of the sort properties
 */
export default function getMailItemSortByProperty(tableQuery) {
    var sortBy = tableQuery.sortBy;
    var primarySortPropertyUri;
    var isExtendedPropertyUri;
    switch (sortBy.sortColumn) {
        case 0 /* Date */:
            // When table supports sorting by renew time,
            // ReceivedOrRenewTime is used as primary sort
            if (shouldTableSortByRenewTime(tableQuery)) {
                primarySortPropertyUri = 'ReceivedOrRenewTime';
            }
            break;
        case 1 /* From */:
            isExtendedPropertyUri = true;
            // Use the display name for sort column From and not the smtp address
            primarySortPropertyUri = extendedPropertyUri({
                PropertyTag: '0x0042',
                PropertyType: 'String',
            });
            break;
        case 2 /* Size */:
            primarySortPropertyUri = 'Size';
            break;
        default:
            throw new Error('getMailItemSortByProperty: sort column not supported' + sortBy.sortColumn);
    }
    // Add primary SortResult
    var sortByResults = [];
    if (primarySortPropertyUri) {
        var propertyUriPath = primarySortPropertyUri;
        if (!isExtendedPropertyUri) {
            propertyUriPath = propertyUri({ FieldURI: primarySortPropertyUri });
        }
        sortByResults.push(sortResults({
            Order: sortBy.sortDirection,
            Path: propertyUriPath,
        }));
    }
    // For non-date sorts the secondary sort direction will always default to descending.
    // For date sort we want to honour users selection of direction
    var secondarySortDirection = tableQuery.sortBy.sortColumn == 0 /* Date */
        ? tableQuery.sortBy.sortDirection
        : MailSortHelper.DESCENDING_SORT_DIR;
    // Add secondary SortResult of DateTimeReceived for all sort tyoes.
    // Currently only descending sort order is supported
    sortByResults.push(sortResults({
        Order: secondarySortDirection,
        Path: propertyUri({ FieldURI: 'DateTimeReceived' }),
    }));
    return sortByResults;
}
//# sourceMappingURL=getMailItemSortByProperty.js.map